module.exports = __webpack_public_path__ + "images/emoji/coffee.92a113e451472d152578.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/coffee.png
// module id = kDDD
// module chunks = 14